import { lazy } from "react";
import { app } from "~/helpers/routes";
import { paths } from "~/router/paths";

const AdSpyToolV2 = lazy(() => import("~/pages/ad-spy-tool-v2"));
const AdInfo = lazy(() => import("~/pages/ad-spy-tool/components/AdInfo"));

export const routes: Array<any> = [
  {
    path: paths.adSpyTool.index,
    element: app(AdSpyToolV2),
  },
  {
    path: paths.adSpyTool.adInfo,
    element: app(AdInfo),
  },
];
